import { render, staticRenderFns } from "./Alreadytest.vue?vue&type=template&id=64adf3b3&style=height%3A%20100%25%3B"
import script from "./Alreadytest.vue?vue&type=script&lang=js"
export * from "./Alreadytest.vue?vue&type=script&lang=js"
import style0 from "./Alreadytest.vue?vue&type=style&index=0&id=64adf3b3&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports